module.exports = __webpack_public_path__ + "img/alter-ego-tablet_en.c232239.jpg";